import { useEffect, useState } from "react";
import { useFetcher, useNavigate, useParams } from "react-router-dom";

import { Button } from "@/components/clickable";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "@/components/dialog";
import { FileDropzone } from "@/components/forms";
import { HStack, VStack } from "@/components/layout";
import ProgressBar from "@/components/progress-bar";
import { getProjectPath } from "@/modules/get-path";
import { useUpload } from "@/modules/upload";

export default function CreateStatementsView() {
  const { upload, progress, errorsByFile } = useUpload();
  const fetcher = useFetcher();
  const [files, setFiles] = useState([]);
  let { projectSlug } = useParams();
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);

  let [isOpen, setIsOpen] = useState(true);

  const createStatements = (blobs) => {
    const hasFiles = blobs.length > 0;
    if (hasFiles) {
      const formData = new FormData();
      blobs.forEach(({ signedId }) => formData.append("blobsIds", signedId));
      fetcher.submit(formData, { method: "post" });
    }
  };

  const submit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (!files.length) {
      setIsOpen(false);
    }

    upload(files).then((blobs) => createStatements(blobs));
  };

  const close = () => setIsOpen(false);

  useEffect(() => {
    if (!isOpen) {
      const path = getProjectPath(projectSlug);
      navigate(path);
    }
  }, [isOpen]);

  useEffect(() => {
    // TODO: Handle errors
    // Upload errors: `errorsByFile.filter((error) => error)`
    // Create statements errors: fetcher.data.errors
  }, [fetcher.data, errorsByFile]);

  return (
    <Dialog
      open={isOpen}
      as="div"
      size="lg"
      className="relative z-10 shadow-2xl ring-0 focus:outline-none"
      onClose={close}
      __demoMode
    >
      <DialogTitle as="h3" className="text-base/7 font-medium text-black">
        Upload PDF statements
      </DialogTitle>
      {progress.percent > 0 ? (
        <ProgressBar className="my-4" progress={progress.percent} />
      ) : (
        <>
          <DialogDescription className="mt-2 text-sm/6">
            Upload bank statements or credit card statements.
          </DialogDescription>
          <DialogBody>
            <VStack>
              <div className="mt-4 w-full">
                <FileDropzone
                  accept={{ "application/pdf": [".pdf"] }}
                  maxSize={20}
                  setFiles={setFiles}
                  files={files}
                />
              </div>
            </VStack>
          </DialogBody>
        </>
      )}
      <DialogActions>
        <HStack className="w-full justify-end">
          <Button
            onClick={close}
            color="white"
            disabled={submitted || progress.percent > 0}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={submit}
            isLoading={progress.percent > 0}
            disabled={submitted || progress.percent > 0 || files.length === 0}
          >
            Upload PDF statements
          </Button>
        </HStack>
      </DialogActions>
    </Dialog>
  );
}
